module.exports = __webpack_public_path__ + "static/media/icon-placards.74b85d16.svg";